export default "__VITE_ASSET__CWEddmIm__"